import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { pageTitleFor } from './NavConfig';
import { ThemeToggle } from './ThemeToggle';
import { TenantSwitcher } from './TenantSwitcher';
import { BusinessTypeSwitcher } from './BusinessTypeSwitcher';
import { PlanBadge } from './PlanBadge';
import { UserMenu } from './UserMenu';
import { WhatsNewBadge } from './WhatsNewBadge';

interface Props {
  collapsed: boolean;
  onToggleCollapsed: () => void;
  onOpenPlanModal: () => void;
}

export function Header({ collapsed, onToggleCollapsed, onOpenPlanModal }: Props) {
  const loc = useLocation();
  const title = pageTitleFor(loc.pathname);

  return (
    <header className={clsx('ts-header', collapsed && 'collapsed')}>
      <button
        type="button"
        className="ts-toggle-btn"
        onClick={onToggleCollapsed}
        title="Sidebar"
        aria-label="Sidebar"
      >
        <i className="bi bi-list" />
      </button>
      <div>
        <div className="ts-header-title">{title}</div>
        <div className="ts-header-bc">
          TseTsu <i className="bi bi-chevron-right" style={{ fontSize: '0.6rem' }} /> {title}
        </div>
      </div>
      <div className="ts-header-spacer" />
      <WhatsNewBadge />
      <ThemeToggle />
      <TenantSwitcher />
      <BusinessTypeSwitcher />
      <PlanBadge onClick={onOpenPlanModal} />
      <UserMenu />
    </header>
  );
}
